import axiosInstance from 'apis/axiosInstance';
import useSWR from 'swr';

const useInsuranceStatus = () => {
  const url = `/admin/insurances/status`;

  // NO AUTO UPDATE _ NEED TO MANUALLY TRIGGER
  const { data, error, mutate } = useSWR(
    url,
    async (url) => {
      const response = await axiosInstance.get<{
        isSameAcceptedStatus: boolean;
        isAllActive: boolean;
        isAllInNetwork: boolean;
        isSameInNetworkStatus: boolean;
        isAllOutOfNetwork: boolean;
        isSameOutOfNetworkStatus: boolean;
      }>(url);
      return response.data;
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  return {
    data,
    error,
    isLoading: !data && !error,
    mutate,
  };
};

export default useInsuranceStatus;
